export default "__VITE_PUBLIC_ASSET__d5dbba3b__"